import getDays from "./getDate";

export default function getSeasonConfig() {
  let seasonConfig = [];

  seasonConfig[0] = {};

  seasonConfig[0].name = "Tournament of Triumph";
  seasonConfig[0].start = new Date("January 30, 2026 00:00:00 GMT-8:00");
  seasonConfig[0].end = new Date("February 13, 2026 00:00:00 GMT-8:00");
  seasonConfig[0].baseTickets = 5;
  seasonConfig[0].bonusTickets = 0;

  seasonConfig[0].phases = [];

  seasonConfig[0].phases[0] = {};
  seasonConfig[0].phases[0].start = new Date(
    "January 30, 2026 00:00:00 GMT-8:00",
  );
  seasonConfig[0].phases[0].end = new Date(
    "February 13, 2026 00:00:00 GMT-8:00",
  );
  seasonConfig[0].phases[0].baseTickets = 5;
  seasonConfig[0].phases[0].poolTickets = 15;

  seasonConfig[0].spirits = [];

  seasonConfig[0].spirits[0] = {};
  seasonConfig[0].spirits[0].name = "";
  seasonConfig[0].spirits[0].items = [];

  //  seasonConfig[0].spirits[0].items[4] = {};
  //
  //  seasonConfig[0].spirits[0].items[4].middle = {};
  //  seasonConfig[0].spirits[0].items[4].middle.name = 'Random Dye Blessing';
  //  seasonConfig[0].spirits[0].items[4].middle.type = '';
  //  seasonConfig[0].spirits[0].items[4].middle.price = 10;
  //  seasonConfig[0].spirits[0].items[4].middle.sp = false;
  //  seasonConfig[0].spirits[0].items[4].middle.enabled = true;
  //
  //  seasonConfig[0].spirits[0].items[4].left = {};
  //  seasonConfig[0].spirits[0].items[4].left.name = '';
  //  seasonConfig[0].spirits[0].items[4].left.type = '';
  //  seasonConfig[0].spirits[0].items[4].left.price = 0;
  //  seasonConfig[0].spirits[0].items[4].left.sp = true;
  //  seasonConfig[0].spirits[0].items[4].left.enabled = true;
  //
  //  seasonConfig[0].spirits[0].items[3] = {};
  //
  //  seasonConfig[0].spirits[0].items[3].middle = {};
  //  seasonConfig[0].spirits[0].items[3].middle.name = 'Random Dye Blessing';
  //  seasonConfig[0].spirits[0].items[3].middle.type = '';
  //  seasonConfig[0].spirits[0].items[3].middle.price = 10;
  //  seasonConfig[0].spirits[0].items[3].middle.sp = false;
  //  seasonConfig[0].spirits[0].items[3].middle.enabled = true;
  //
  //  seasonConfig[0].spirits[0].items[3].left = {};
  //  seasonConfig[0].spirits[0].items[3].left.name = '';
  //  seasonConfig[0].spirits[0].items[3].left.type = '';
  //  seasonConfig[0].spirits[0].items[3].left.price = 0;
  //  seasonConfig[0].spirits[0].items[3].left.sp = true;
  //  seasonConfig[0].spirits[0].items[3].left.enabled = true;

  //  seasonConfig[0].spirits[0].items[2] = {};
  //
  //  seasonConfig[0].spirits[0].items[2].middle = {};
  //  seasonConfig[0].spirits[0].items[2].middle.name = 'Mischief Beak Mask';
  //  seasonConfig[0].spirits[0].items[2].middle.type = '';
  //  seasonConfig[0].spirits[0].items[2].middle.price = 22;
  //  seasonConfig[0].spirits[0].items[2].middle.sp = false;
  //  seasonConfig[0].spirits[0].items[2].middle.enabled = true;
  //
  //  seasonConfig[0].spirits[0].items[2].left = {};
  //  seasonConfig[0].spirits[0].items[2].left.name = '';
  //  seasonConfig[0].spirits[0].items[2].left.type = '';
  //  seasonConfig[0].spirits[0].items[2].left.price = 0;
  //  seasonConfig[0].spirits[0].items[2].left.sp = true;
  //  seasonConfig[0].spirits[0].items[2].left.enabled = true;

  seasonConfig[0].spirits[0].items[1] = {};

  seasonConfig[0].spirits[0].items[1].middle = {};
  seasonConfig[0].spirits[0].items[1].middle.name = "Ice Board";
  seasonConfig[0].spirits[0].items[1].middle.type = "";
  seasonConfig[0].spirits[0].items[1].middle.price = 48;
  seasonConfig[0].spirits[0].items[1].middle.sp = false;
  seasonConfig[0].spirits[0].items[1].middle.enabled = true;

  seasonConfig[0].spirits[0].items[1].left = {};
  seasonConfig[0].spirits[0].items[1].left.name = "";
  seasonConfig[0].spirits[0].items[1].left.type = "";
  seasonConfig[0].spirits[0].items[1].left.price = 0;
  seasonConfig[0].spirits[0].items[1].left.sp = true;
  seasonConfig[0].spirits[0].items[1].left.enabled = true;

  seasonConfig[0].spirits[0].items[0] = {};

  seasonConfig[0].spirits[0].items[0].middle = {};
  seasonConfig[0].spirits[0].items[0].middle.name = "Helmet Hair";
  seasonConfig[0].spirits[0].items[0].middle.type = "";
  seasonConfig[0].spirits[0].items[0].middle.price = 12;
  seasonConfig[0].spirits[0].items[0].middle.sp = false;
  seasonConfig[0].spirits[0].items[0].middle.enabled = true;

  seasonConfig[0].spirits[0].items[0].left = {};
  seasonConfig[0].spirits[0].items[0].left.name = "";
  seasonConfig[0].spirits[0].items[0].left.type = "";
  seasonConfig[0].spirits[0].items[0].left.price = 0;
  seasonConfig[0].spirits[0].items[0].left.sp = true;
  seasonConfig[0].spirits[0].items[0].left.enabled = true;

  seasonConfig[1] = {};

  seasonConfig[1].name = "Days of Feast";
  seasonConfig[1].start = new Date("December 12, 2025 00:00:00 GMT-8:00");
  seasonConfig[1].end = new Date("January 2, 2026 00:00:00 GMT-8:00");
  seasonConfig[1].baseTickets = 5;
  seasonConfig[1].bonusTickets = 0;

  seasonConfig[1].phases = [];

  seasonConfig[1].phases[0] = {};
  seasonConfig[1].phases[0].start = new Date(
    "December 12, 2025 00:00:00 GMT-8:00",
  );
  seasonConfig[1].phases[0].end = new Date("January 2, 2025 00:00:00 GMT-8:00");
  seasonConfig[1].phases[0].baseTickets = 5;
  seasonConfig[1].phases[0].poolTickets = 15;

  seasonConfig[1].spirits = [];

  seasonConfig[1].spirits[0] = {};
  seasonConfig[1].spirits[0].name = "";
  seasonConfig[1].spirits[0].items = [];

  //  seasonConfig[1].spirits[0].items[2] = {};
  //
  //  seasonConfig[1].spirits[0].items[2].middle = {};
  //  seasonConfig[1].spirits[0].items[2].middle.name = 'Purple Dye Jar (x3)';
  //  seasonConfig[1].spirits[0].items[2].middle.type = '';
  //  seasonConfig[1].spirits[0].items[2].middle.price = 75;
  //  seasonConfig[1].spirits[0].items[2].middle.sp = false;
  //  seasonConfig[1].spirits[0].items[2].middle.enabled = true;
  //
  //  seasonConfig[1].spirits[0].items[2].left = {};
  //  seasonConfig[1].spirits[0].items[2].left.name = '';
  //  seasonConfig[1].spirits[0].items[2].left.type = '';
  //  seasonConfig[1].spirits[0].items[2].left.price = 0;
  //  seasonConfig[1].spirits[0].items[2].left.sp = true;
  //  seasonConfig[1].spirits[0].items[2].left.enabled = true;

  seasonConfig[1].spirits[0].items[1] = {};

  seasonConfig[1].spirits[0].items[1].middle = {};
  seasonConfig[1].spirits[0].items[1].middle.name = "Winter Shawl Cape";
  seasonConfig[1].spirits[0].items[1].middle.type = "";
  seasonConfig[1].spirits[0].items[1].middle.price = 45;
  seasonConfig[1].spirits[0].items[1].middle.sp = false;
  seasonConfig[1].spirits[0].items[1].middle.enabled = true;

  seasonConfig[1].spirits[0].items[1].left = {};
  seasonConfig[1].spirits[0].items[1].left.name = "";
  seasonConfig[1].spirits[0].items[1].left.type = "";
  seasonConfig[1].spirits[0].items[1].left.price = 0;
  seasonConfig[1].spirits[0].items[1].left.sp = true;
  seasonConfig[1].spirits[0].items[1].left.enabled = true;

  seasonConfig[1].spirits[0].items[0] = {};

  seasonConfig[1].spirits[0].items[0].middle = {};
  seasonConfig[1].spirits[0].items[0].middle.name = "Winter Coat Outfit";
  seasonConfig[1].spirits[0].items[0].middle.type = "";
  seasonConfig[1].spirits[0].items[0].middle.price = 39;
  seasonConfig[1].spirits[0].items[0].middle.sp = true;
  seasonConfig[1].spirits[0].items[0].middle.enabled = true;

  seasonConfig[1].spirits[0].items[0].left = {};
  seasonConfig[1].spirits[0].items[0].left.name = "";
  seasonConfig[1].spirits[0].items[0].left.type = "";
  seasonConfig[1].spirits[0].items[0].left.price = 0;
  seasonConfig[1].spirits[0].items[0].left.sp = true;
  seasonConfig[1].spirits[0].items[0].left.enabled = true;

  let currentSeason = 0;
  let closestDate = new Date("January 1, 1970 00:00:00 GMT0:00");

  seasonConfig.some((season, seasonIndex) => {
    if (getDays(season.start) < 1 && getDays(season.end) > 0) {
      currentSeason = seasonIndex;
      return true;
    } else {
      let closestDays = getDays(closestDate);
      let seasonDays = getDays(season.start);
      if (closestDays > 0) {
        if (closestDays > seasonDays && seasonDays > 0) {
          closestDate = season.start;
          currentSeason = seasonIndex;
        }
      } else {
        if (seasonDays > 0) {
          closestDate = season.start;
          currentSeason = seasonIndex;
        } else if (getDays(season.end) > closestDays) {
          closestDate = season.end;
          currentSeason = seasonIndex;
        }
      }
      return false;
    }
  });

  return seasonConfig[currentSeason];
}
